import { motion, Reorder } from "framer-motion"
import { useAppUserAccess } from 'global/cnr/contexts/useHelpers/useAppUserAccess'
import { gEnums } from 'global/enums/globalEnums'
import { _longPressTypes, LongPressWrapper, LPW } from 'global/wrappers/LongPressWrapper'
import _ from 'lodash'
import React, { useContext, useMemo, useState } from 'react'
import { Divider, Header, Icon, Menu } from 'semantic-ui-react'
import { FrameworkContext } from '../../cnr/contexts/FrameworkContent'
import { NavigationContext } from '../../cnr/contexts/NavigationContext'
import { ParentContext } from '../../cnr/contexts/ParentContext'
import { uniqueKey } from '../../common/keys'
import { allPageTypes, fullPageTypes } from '../../enums/allPageTypes'
import { DesktopContext } from '../../wrappers/DesktopWrapper'
import { gridIconElements } from './gridItems/SegIconGroup'
import { useStyles } from "global/cnr/contexts/useHelpers/useStyles"

export const permissionGroupTypes = {
  page: 'page',
  appUser: 'appUser',
  appAdmin: 'appAdmin',
  ticketing: 'ticketing',
  admin: 'admin',
  pageHidden: 'pageHidden',
}

const IconGrid = (props) => {

  const { permissionGroupType } = props

  // parentContext
  const parentContext = useContext(ParentContext);
  const { states, fns } = parentContext ?? {}
  const { appSettings_state, page_state, currentSettings_state, appUser_state, paps_state } = states ?? {}
  const { appSettings_fns } = fns ?? {}
  const { pathViews } = paps_state ?? {}

  const { aps_global } = _.get(currentSettings_state, 'gvviSettings', {});
  const { aps_page } = _.get(page_state, 'pageSettings', {});

  const { layout: layout_page, viewItems } = aps_page ?? {}
  const { iconsPerRow } = layout_page ?? {}
  const { gridIcons } = aps_global && aps_global.themedItems ? aps_global.themedItems : {}
  const { iconsPerRow: iconsPerRow_gi, textLimit } = gridIcons ?? {}

  let { desktopMode } = appSettings_state ?? {}

  const { appUser } = appUser_state ?? {}
  const appUserAccess = useAppUserAccess()
  const { accessLevel, displayName } = appUserAccess ?? {}

  const allowSort = accessLevel >= gEnums.accessLevels.appAdmin.value

  // desktopContext
  const desktopContext = useContext(DesktopContext);
  const { desktop_state, desktop_handlers } = desktopContext ?? {}
  const { handleItemClick } = desktop_handlers ?? {}
  const { forDesktop } = desktop_state ?? {}

  // frameworkContext
  const frameworkContext = useContext(FrameworkContext);
  const { framework_state, framework_handlers } = frameworkContext ?? {}
  const { permissionGroups } = framework_state ?? {}
  const { handleClick_contentItem } = framework_handlers ?? {}

  // navigationContext
  const navigationContext = useContext(NavigationContext);
  const { navigation_fns } = navigationContext ?? {}

  const styleFns = useStyles()

  const xxx = styleFns.setStyleAndClass({ item: gEnums.projectStyles.defaultTheme, forLine: true })

  const [showSort, setShowSort] = useState()
  const [allowSave, setAllowSave] = useState()

  const handleIconClick = (navProps) => {
    if (showSort) return;
    const { clickedItem } = navProps ?? {}
    const { key } = clickedItem ?? {}
    const viewItem = viewItems?.[key]
    const { itemClick } = viewItem ?? {}
    const { clickToType, url } = itemClick ?? {}

    switch (clickToType) {
      case gEnums.clickToTypes.url:
        window.open(url, '_blank')
        return;
    }

    if (handleItemClick) {
      handleItemClick(navProps)
    } else {
      if (fullPageTypes[key]) {
        handleClick_contentItem(navProps)
      } else {
        switch (key) {
          case allPageTypes.weather:
            handleClick_contentItem(navProps)
            break;
          default:
            navigation_fns.handleNav(navProps)
        }
      }
    }

  }

  const _gridItemGroup = permissionGroups?.[permissionGroupType]
  const gridItems = gridIconElements({ gridItemGroup: _gridItemGroup, handleIconClick, textLimit })

  const [_gridItems, set_gridItems] = useState(gridItems)

  const handleShowSort = () => setShowSort(!showSort)

  const handleClose = () => {
    setShowSort(false)
    setAllowSave(false)
  }

  const handleSaveIcons = async () => {
    const view_items = _.mapValues(_gridItems, 'viewItem');
    const { aps_views } = _.clone(_.get(currentSettings_state, 'gvviSettings', {}));
    const { events: aps_events } = aps_views ?? {}
    const { viewItems } = aps_events ?? {}
    _.forEach(view_items, (vi, position) => {
      if (viewItems[vi.key]) {
        viewItems[vi.key].position = Number(position)
      }
    })
    // pathViews, docFieldKey
    appSettings_fns.updateViewViewItems(pathViews, 'events', viewItems, appUser)
    setShowSort(false)
  }


  const globalIconsPerRow = iconsPerRow_gi ? iconsPerRow_gi : 3
  let _iconsPerRow = iconsPerRow ? iconsPerRow : globalIconsPerRow

  if (forDesktop) {
    _iconsPerRow = 1
  }

  const dividerText = useMemo(() => {
    switch (permissionGroupType) {
      case permissionGroupTypes.admin:
        return 'Admin Only'
      case permissionGroupTypes.appAdmin:
        return 'App Admin Only'
      case permissionGroupTypes.appUser:
        return displayName
      case permissionGroupTypes.pageHidden:
        return 'Admin Hidden'
      case permissionGroupTypes.ticketing:
        return 'Ticketing'
    }
  }, [permissionGroupType])

  const gridDiv = (gridItem, index) => <motion.div key={index} layout className={'grd-item'} >
    {gridItem.element}
  </motion.div>

  const setIcons = (x) => {
    set_gridItems(x)
    setAllowSave(true)
  }

  const rog = () => <Reorder.Group
    axis="y"
    as="div"
    values={_gridItems}
    onReorder={setIcons}
    className={`grid-icons norm clm-${_iconsPerRow} drg`}
  >
    {_.map(_gridItems, (gridItem) => (
      <Reorder.Item
        key={gridItem?.viewItem?.key}
        value={gridItem}
        whileDrag={{
          scale: 1.05,
          boxShadow: "0 5px 10px rgba(0,0,0,0.2)",
        }}
        transition={{ type: "spring", stiffness: 500, damping: 40 }}
        // dragConstraints={{ top: 0, left: 0, right: 0, bottom: 0 }} // optional
        className="grd-item"
        layout
        drag
      >
        {gridItem.element}
      </Reorder.Item>
    ))}
  </Reorder.Group>

  const grid = useMemo(() => {
    if (!_gridItems) return []
    if (forDesktop || desktopMode) {
      return <Menu key={uniqueKey('igr')} size='mini'>
        {_.map(_gridItems, (gridItem, index) => gridDiv(gridItem, index))}
      </Menu>
    } else {
      if (showSort) {
        return <div className='igr-drg-container'>
          <div className='igr-drg-hdr'>
            <Icon name='delete' color='red' onClick={() => { handleClose() }} />
            <Icon name='save' color={allowSave ? 'blue' : 'grey'} disabled={!allowSave} style={{ float: 'right' }} onClick={() => { allowSave && handleSaveIcons() }} />
          </div>
          {rog()}
        </div>
      } else {
        return <LPW
          longPressType={_longPressTypes.default}
          handleOnPress={allowSort && handleShowSort}
        >
          <div key={uniqueKey('igr')} className={`grid-icons norm clm-${_iconsPerRow}`} >
            {_.map(_gridItems, (gridItem, index) => gridDiv(gridItem, index))}
          </div>
        </LPW>
      }

    }
  }, [_gridItems, desktopMode, showSort])

  const gridWithDivider = () => <React.Fragment>
    {dividerText && <Divider horizontal>
      <Header style={{ color: xxx.style.color, margin: '.5em' }} size="tiny">
        {dividerText}
      </Header>
    </Divider>}
    {grid}
  </React.Fragment>

  return desktopMode ? grid : gridWithDivider()

}

export default IconGrid